export default "__VITE_ASSET__PCLGkNlm__"